(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 749px)';
  var REDUCED_MOTION_MQ = '(prefers-reduced-motion: reduce)';
  var RESUME_DELAY_MS = 6000;

  function init(sliderComponent) {
    if (sliderComponent.__multicolumnInit) return;
    sliderComponent.__multicolumnInit = true;

    var track = sliderComponent.querySelector('.slider');
    if (!track) return;

    var autoplayEnabled = sliderComponent.hasAttribute('data-mobile-autoplay');
    var dotsEnabled = sliderComponent.hasAttribute('data-mobile-pagination-dots');

    var speedAttr = parseFloat(sliderComponent.getAttribute('data-autoplay-speed'));
    var intervalMs = (isFinite(speedAttr) && speedAttr > 0 ? speedAttr : 4) * 1000;

    var mobileMql = window.matchMedia(MOBILE_MQ);
    var motionMql = window.matchMedia(REDUCED_MOTION_MQ);

    var intervalId = null;
    var resumeTimeoutId = null;

    var dots = dotsEnabled
      ? sliderComponent.querySelectorAll('.multicolumn__pagination .slider-counter__link')
      : [];

    function clearTimers() {
      if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
      }
      if (resumeTimeoutId !== null) {
        clearTimeout(resumeTimeoutId);
        resumeTimeoutId = null;
      }
    }

    function tick() {
      if (!mobileMql.matches || motionMql.matches) return;
      if (document.hidden) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 1) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      if (intervalId !== null) return;
      if (!mobileMql.matches || motionMql.matches) return;
      intervalId = setInterval(tick, intervalMs);
    }

    function stopAutoplay() {
      clearTimers();
    }

    function pauseAndScheduleResume() {
      if (!autoplayEnabled) return;
      clearTimers();
      resumeTimeoutId = setTimeout(function () {
        resumeTimeoutId = null;
        startAutoplay();
      }, RESUME_DELAY_MS);
    }

    var rafId = null;
    function updateActiveDot() {
      if (!dotsEnabled || dots.length === 0) return;
      var slideWidth = track.clientWidth;
      if (slideWidth <= 0) return;
      var index = Math.round(track.scrollLeft / slideWidth);
      if (index < 0) index = 0;
      if (index > dots.length - 1) index = dots.length - 1;
      for (var i = 0; i < dots.length; i++) {
        if (i === index) {
          dots[i].classList.add('slider-counter__link--active');
        } else {
          dots[i].classList.remove('slider-counter__link--active');
        }
      }
    }

    function onTrackScroll() {
      if (rafId !== null) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        updateActiveDot();
      });
    }

    if (dotsEnabled && dots.length > 0) {
      track.addEventListener('scroll', onTrackScroll, { passive: true });

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          var target = index * track.clientWidth;
          track.scrollTo({ left: target, behavior: 'smooth' });
          pauseAndScheduleResume();
        });
      });

      updateActiveDot();
    }

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
      track.addEventListener(evt, pauseAndScheduleResume, { passive: true });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    function onMediaChange() {
      if (autoplayEnabled && mobileMql.matches && !motionMql.matches) {
        startAutoplay();
      } else {
        stopAutoplay();
      }
    }

    if (typeof mobileMql.addEventListener === 'function') {
      mobileMql.addEventListener('change', onMediaChange);
      motionMql.addEventListener('change', onMediaChange);
    } else if (typeof mobileMql.addListener === 'function') {
      mobileMql.addListener(onMediaChange);
      motionMql.addListener(onMediaChange);
    }

    onMediaChange();
  }

  function initAll(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll(
      'slider-component[data-mobile-autoplay], slider-component[data-mobile-pagination-dots]'
    );
    nodes.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
